"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconByLinkType = void 0;
var _icons = require("@ori-ui/icons");
var _jsxRuntime = require("react/jsx-runtime");
const getIconByLinkType = linkType => {
  switch (linkType) {
    case 'Catalogue':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Catalogue, {});
    case 'FocusPage':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.DiscountTag, {});
    case 'Inspiration':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Products, {});
    case 'BeautyTips':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.WhatsNew, {});
    case 'Gifts':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Gift, {});
    default:
      return null;
  }
};
exports.getIconByLinkType = getIconByLinkType;
